import React, { useState } from "react";
import { Sigma, Calculator, FileSpreadsheet, SlidersHorizontal } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { Calculadora } from "@/pages/motor/Calculadora";
import { CotizacionesList } from "@/pages/motor/CotizacionesList";
import { CentroFormulas } from "@/pages/motor/CentroFormulas";

export default function MotorCalculoPage() {
  const { user } = useAuth();
  const isAdmin = !!user?.is_admin;
  const [tab, setTab] = useState("calculadora");

  return (
    <div className="space-y-5" data-testid="motor-calculo-page">
      <div>
        <h1 className="flex items-center gap-2 font-heading text-2xl font-bold tracking-tight">
          <Sigma className="h-6 w-6 text-primary" /> Motor de cálculo
        </h1>
        <p className="text-sm text-muted-foreground">Cotiza al céntimo y gestiona las fórmulas por partner · Iteración 2 (POC).</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="motor-tabs">
          <TabsTrigger value="calculadora" data-testid="tab-calculadora"><Calculator className="mr-1.5 h-4 w-4" />Calculadora</TabsTrigger>
          <TabsTrigger value="cotizaciones" data-testid="tab-cotizaciones"><FileSpreadsheet className="mr-1.5 h-4 w-4" />Cotizaciones</TabsTrigger>
          {isAdmin && <TabsTrigger value="formulas" data-testid="tab-formulas"><SlidersHorizontal className="mr-1.5 h-4 w-4" />Centro de fórmulas</TabsTrigger>}
        </TabsList>
        <TabsContent value="calculadora" className="mt-4"><Calculadora onSaved={() => setTab("cotizaciones")} /></TabsContent>
        <TabsContent value="cotizaciones" className="mt-4"><CotizacionesList /></TabsContent>
        {isAdmin && <TabsContent value="formulas" className="mt-4"><CentroFormulas /></TabsContent>}
      </Tabs>
    </div>
  );
}
